var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "help",
          on: {
            mouseenter: function($event) {
              _vm.cancel = true
            },
            mouseleave: function($event) {
              _vm.cancel = false
            }
          }
        },
        [
          _c("img", {
            staticStyle: { cursor: "pointer" },
            attrs: {
              src:
                "../../static/images/" +
                (!_vm.cancel ? "help.svg" : "cancel.svg"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              style: {
                cursor: "pointer",
                paddingBottom: "10px",
                position: "absolute",
                top: "-53px",
                left: _vm.$store.state.lang !== "en" ? "-113px" : "-132px"
              }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.cancel,
                      expression: "cancel"
                    }
                  ],
                  staticStyle: {
                    padding: "10px",
                    display: "flex",
                    "justify-content": "space-around",
                    "align-items": "center",
                    "border-radius": "5px",
                    background: "#fff"
                  },
                  on: { click: _vm.showLittleHelp }
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        display: "flex",
                        "align-items": "center"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("litter_helper.eMoment_litter_helper")
                          ) +
                          "\n        "
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "modal",
          staticClass: "helperModal",
          attrs: {
            closable: false,
            width: "1036px",
            "footer-hide": "",
            styles: {
              top: "calc((100vh - 660px) / 2)"
            }
          },
          model: {
            value: _vm.modal1,
            callback: function($$v) {
              _vm.modal1 = $$v
            },
            expression: "modal1"
          }
        },
        [
          _c(
            "div",
            { staticClass: "header", staticStyle: { "margin-bottom": "15px" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between"
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "font-size": "20px", color: "#111" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("litter_helper.eMoment_litter_helper")
                          ) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "search",
                      staticStyle: {
                        display: "flex",
                        outline: "none",
                        "align-items": "center"
                      },
                      attrs: { tabindex: "0" }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { position: "relative" } },
                        [
                          _c(
                            "Input",
                            {
                              ref: "search",
                              staticStyle: { width: "auto" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "litter_helper.search_placeholder"
                                ),
                                clearable: ""
                              },
                              on: {
                                "on-focus": _vm.searchFocus,
                                "on-blur": _vm.searchBlur,
                                "on-keyup": function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.searchDocument.apply(
                                    null,
                                    arguments
                                  )
                                }
                              },
                              model: {
                                value: _vm.search_keywords,
                                callback: function($$v) {
                                  _vm.search_keywords =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "search_keywords"
                              }
                            },
                            [
                              _c("Icon", {
                                attrs: { slot: "prefix", type: "ios-search" },
                                slot: "prefix"
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowHistory,
                                  expression: "isShowHistory"
                                }
                              ],
                              staticClass: "search_history",
                              on: { mousedown: _vm.clickHistoryHandler }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "history",
                                  staticStyle: {
                                    "margin-top": "10px",
                                    "margin-left": "12px"
                                  }
                                },
                                [
                                  _c(
                                    "h5",
                                    {
                                      staticStyle: { "margin-bottom": "10px" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t("litter_helper.history")
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.history_list, function(
                                    item,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: item,
                                        staticClass: "tag",
                                        attrs: { name: item },
                                        on: {
                                          mousedown: function($event) {
                                            return _vm.clickHistory(item)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-right": "3px"
                                            }
                                          },
                                          [_vm._v(_vm._s(item))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "close",
                                            on: {
                                              mousedown: function($event) {
                                                return _vm.delete_history(index)
                                              }
                                            }
                                          },
                                          [
                                            _c("Icon", {
                                              attrs: {
                                                refs: "icon_close",
                                                size: "18",
                                                type: "ios-close"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticStyle: {
                                  height: "1px",
                                  margin: "10px 0",
                                  border: "1px #eee solid"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "clear_history",
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    padding: "0px 12px 10px"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-right": "10px" } },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          "vertical-align": "middle"
                                        },
                                        attrs: {
                                          src: require("../../static/images/dustbin.svg"),
                                          alt: ""
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "content",
                                      on: { mousedown: _vm.clearHistory }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "litter_helper.clear_the_history"
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("Icon", {
                        staticStyle: {
                          "margin-left": "15px",
                          cursor: "pointer"
                        },
                        attrs: { slot: "prefix", type: "md-close", size: "25" },
                        on: {
                          click: function($event) {
                            _vm.modal1 = false
                          }
                        },
                        slot: "prefix"
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "body",
              staticStyle: { color: "#333", "font-size": "17px" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.currentName && !_vm.isSearch,
                      expression: "!currentName && !isSearch"
                    }
                  ],
                  staticStyle: {
                    width: "100%",
                    height: "517px",
                    display: "flex",
                    "justify-content": "space-around",
                    "align-items": "center"
                  }
                },
                _vm._l(_vm.icons, function(name) {
                  return _c(
                    "div",
                    {
                      key: name,
                      staticClass: "classification",
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        "justify-items": "center",
                        "align-items": "center"
                      },
                      on: {
                        click: function($event) {
                          return _vm.clickHandler(name)
                        }
                      }
                    },
                    [
                      _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
                        _c("img", {
                          attrs: {
                            src: "../../static/images/" + name + ".svg",
                            alt: ""
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("litter_helper." + name)))
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentName || _vm.isSearch,
                      expression: "currentName || isSearch"
                    }
                  ],
                  staticStyle: { "margin-bottom": "15px" }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "text-align": "left" } },
                    [
                      _c(
                        "Breadcrumb",
                        {
                          staticStyle: { color: "rgba(153, 153, 153, 1)" },
                          attrs: { separator: ">" }
                        },
                        [
                          _c(
                            "BreadcrumbItem",
                            {
                              staticStyle: { "font-size": "14px", color: "" },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.backHandler.apply(null, arguments)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("litter_helper.eMoment_litter_helper")
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "BreadcrumbItem",
                            {
                              staticStyle: {
                                color: "#333",
                                "font-size": "14px"
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.backClassify.apply(null, arguments)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.currentName))]
                          ),
                          _vm._v(" "),
                          _vm.question
                            ? _c(
                                "BreadcrumbItem",
                                {
                                  staticStyle: {
                                    color: "#333",
                                    "font-size": "14px"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.question))]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "helper_container" },
                [
                  _c(
                    "custom-scroll",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentName,
                          expression: "currentName"
                        }
                      ],
                      ref: "help_father",
                      staticClass: "help_father",
                      attrs: { height: "500px" },
                      on: {
                        scrollEnd: _vm.scrollEndHandler,
                        scroll: _vm.scrollHandler
                      }
                    },
                    [
                      _vm.contentList.length > 0
                        ? [
                            !_vm.answer
                              ? [
                                  _c(
                                    "div",
                                    _vm._l(_vm.phaseList, function(phase) {
                                      return _vm.filter_phase(phase)
                                        ? _c(
                                            "div",
                                            {
                                              key: phase.stage,
                                              staticClass: "phase"
                                            },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "litter_helper." +
                                                        phase.stage
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(_vm.user_roles, function(
                                                role
                                              ) {
                                                return [
                                                  phase[role].length > 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          key: role,
                                                          staticClass: "role",
                                                          staticStyle: {
                                                            "margin-bottom":
                                                              "20px"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "600",
                                                                "font-size":
                                                                  "25px",
                                                                "margin-bottom":
                                                                  "5px"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "litter_helper." +
                                                                        role
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.isSearch
                                                            ? [
                                                                _vm.user_manual_list(
                                                                  phase[role]
                                                                ).length > 0
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle: {
                                                                          "margin-bottom":
                                                                            "20px",
                                                                          "margin-left":
                                                                            "16px"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticStyle: {
                                                                              "font-size":
                                                                                "20px",
                                                                              margin:
                                                                                "10px 0 5px",
                                                                              "font-weight":
                                                                                "600"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "litter_helper.user_manual"
                                                                                  )
                                                                                ) +
                                                                                "\n                          "
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _vm._l(
                                                                          _vm.user_manual_list(
                                                                            phase[
                                                                              role
                                                                            ]
                                                                          ),
                                                                          function(
                                                                            content
                                                                          ) {
                                                                            return _c(
                                                                              "div",
                                                                              {
                                                                                key:
                                                                                  content
                                                                                    .header
                                                                                    .document_id +
                                                                                  role +
                                                                                  "",
                                                                                staticClass:
                                                                                  "search_title"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    attrs: {
                                                                                      "data-el":
                                                                                        "document_" +
                                                                                        content
                                                                                          .header
                                                                                          .document_id
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.search_user_manual_skip(
                                                                                          $event,
                                                                                          role
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "text-highlight",
                                                                                      {
                                                                                        attrs: {
                                                                                          queries:
                                                                                            _vm.hight_words
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n                                " +
                                                                                            _vm._s(
                                                                                              content.title
                                                                                                ? content.title
                                                                                                : content
                                                                                                    .header
                                                                                                    .document_name
                                                                                            ) +
                                                                                            "\n                              "
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ]
                                                                            )
                                                                          }
                                                                        )
                                                                      ],
                                                                      2
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _vm.video_list(
                                                                  phase[role]
                                                                ).length > 0
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle: {
                                                                          "margin-bottom":
                                                                            "20px",
                                                                          "margin-left":
                                                                            "16px"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticStyle: {
                                                                              "font-size":
                                                                                "20px",
                                                                              margin:
                                                                                "10px 0 5px",
                                                                              "font-weight":
                                                                                "600"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "litter_helper.feature_description_video"
                                                                                  )
                                                                                ) +
                                                                                "\n                          "
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _vm._l(
                                                                          _vm.video_list(
                                                                            phase[
                                                                              role
                                                                            ]
                                                                          ),
                                                                          function(
                                                                            content
                                                                          ) {
                                                                            return _c(
                                                                              "div",
                                                                              {
                                                                                key:
                                                                                  content
                                                                                    .header
                                                                                    .document_id,
                                                                                staticClass:
                                                                                  "search_title"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    attrs: {
                                                                                      "data-el":
                                                                                        "document_" +
                                                                                        content
                                                                                          .header
                                                                                          .document_id
                                                                                    },
                                                                                    on: {
                                                                                      click:
                                                                                        _vm.search_video_skip
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "text-highlight",
                                                                                      {
                                                                                        attrs: {
                                                                                          queries:
                                                                                            _vm.hight_words
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n                                " +
                                                                                            _vm._s(
                                                                                              content.title
                                                                                                ? content.title
                                                                                                : content
                                                                                                    .header
                                                                                                    .document_name
                                                                                            ) +
                                                                                            "\n                              "
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ]
                                                                            )
                                                                          }
                                                                        )
                                                                      ],
                                                                      2
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _vm.faq_list(
                                                                  phase[role]
                                                                ).length > 0
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle: {
                                                                          "margin-bottom":
                                                                            "20px",
                                                                          "margin-left":
                                                                            "16px"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticStyle: {
                                                                              "font-size":
                                                                                "20px",
                                                                              margin:
                                                                                "10px 0 5px",
                                                                              "font-weight":
                                                                                "600"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "litter_helper.FAQ"
                                                                                  )
                                                                                ) +
                                                                                "\n                          "
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _vm._l(
                                                                          _vm.faq_list(
                                                                            phase[
                                                                              role
                                                                            ]
                                                                          ),
                                                                          function(
                                                                            content,
                                                                            index
                                                                          ) {
                                                                            return _c(
                                                                              "div",
                                                                              {
                                                                                key:
                                                                                  content
                                                                                    .header
                                                                                    .document_id +
                                                                                  role +
                                                                                  "",
                                                                                staticStyle: {
                                                                                  "margin-bottom":
                                                                                    "15px"
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "search_title"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "p",
                                                                                      {
                                                                                        staticStyle: {
                                                                                          cursor:
                                                                                            "pointer"
                                                                                        },
                                                                                        on: {
                                                                                          click: function(
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.getDocumentDetail(
                                                                                              content
                                                                                                .header
                                                                                                .document_id,
                                                                                              index
                                                                                            )
                                                                                          }
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "text-highlight",
                                                                                          {
                                                                                            attrs: {
                                                                                              queries:
                                                                                                _vm.hight_words
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              "\n                                  " +
                                                                                                _vm._s(
                                                                                                  content.title
                                                                                                ) +
                                                                                                "\n                                "
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          }
                                                                        )
                                                                      ],
                                                                      2
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            : [
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value:
                                                                            _vm.currentName ==
                                                                            _vm.$t(
                                                                              "litter_helper.user_manual"
                                                                            ),
                                                                          expression:
                                                                            "\n                              currentName == $t('litter_helper.user_manual')\n                            "
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "user_manual",
                                                                      on: {
                                                                        click:
                                                                          _vm.previewImgHandler
                                                                      }
                                                                    },
                                                                    _vm._l(
                                                                      _vm.user_manual_list(
                                                                        phase[
                                                                          role
                                                                        ]
                                                                      ),
                                                                      function(
                                                                        document
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            key:
                                                                              document
                                                                                .header
                                                                                .document_id,
                                                                            ref:
                                                                              "document_" +
                                                                              document
                                                                                .header
                                                                                .document_id,
                                                                            refInFor: true,
                                                                            staticClass:
                                                                              "document_title",
                                                                            staticStyle: {
                                                                              "margin-bottom":
                                                                                "20px"
                                                                            },
                                                                            attrs: {
                                                                              "data-role": role
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticStyle: {
                                                                                  "margin-left":
                                                                                    "18px",
                                                                                  "font-weight":
                                                                                    "600",
                                                                                  "margin-bottom":
                                                                                    "5px",
                                                                                  "font-size":
                                                                                    "25px"
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "text-highlight",
                                                                                  {
                                                                                    attrs: {
                                                                                      queries:
                                                                                        _vm.hight_words
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                  " +
                                                                                        _vm._s(
                                                                                          document.title
                                                                                            ? document.title
                                                                                            : document
                                                                                                .header
                                                                                                .document_name
                                                                                        ) +
                                                                                        "\n                                "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            document.content
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "user_manual_content",
                                                                                    staticStyle: {
                                                                                      "margin-left":
                                                                                        "18px"
                                                                                    },
                                                                                    domProps: {
                                                                                      innerHTML: _vm._s(
                                                                                        document
                                                                                          .content
                                                                                          .content
                                                                                      )
                                                                                    }
                                                                                  }
                                                                                )
                                                                              : _vm._e()
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                ],
                                                                _vm._v(" "),
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value:
                                                                            _vm.currentName ==
                                                                            _vm.$t(
                                                                              "litter_helper.feature_description_video"
                                                                            ),
                                                                          expression:
                                                                            "\n                              currentName ==\n                                $t('litter_helper.feature_description_video')\n                            "
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "content_wrap"
                                                                    },
                                                                    _vm._l(
                                                                      _vm.video_list(
                                                                        phase[
                                                                          role
                                                                        ]
                                                                      ),
                                                                      function(
                                                                        video,
                                                                        index
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            key:
                                                                              video
                                                                                .header
                                                                                .document_id,
                                                                            ref:
                                                                              "document_" +
                                                                              video
                                                                                .header
                                                                                .document_id,
                                                                            refInFor: true,
                                                                            staticClass:
                                                                              "item",
                                                                            style: {
                                                                              marginRight:
                                                                                index +
                                                                                  (1 %
                                                                                    4) ==
                                                                                  0 &&
                                                                                index !=
                                                                                  0
                                                                                  ? "0"
                                                                                  : "14px"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "video_cover",
                                                                                style: {
                                                                                  backgroundImage:
                                                                                    "url(" +
                                                                                    (video.media &&
                                                                                    video
                                                                                      .media[0] &&
                                                                                    video
                                                                                      .media[0]
                                                                                      .media_thumb_url
                                                                                      ? video
                                                                                          .media[0]
                                                                                          .media_thumb_url
                                                                                      : "../../static/images/暂无图片1.svg") +
                                                                                    ")"
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "zoom"
                                                                                  }
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "play",
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.playVideo(
                                                                                          video
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "img",
                                                                                      {
                                                                                        attrs: {
                                                                                          src: require("../../static/images/play.svg"),
                                                                                          alt:
                                                                                            ""
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "video_title"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "text-highlight",
                                                                                  {
                                                                                    attrs: {
                                                                                      queries:
                                                                                        _vm.hight_words
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                  " +
                                                                                        _vm._s(
                                                                                          video.title
                                                                                            ? video.title
                                                                                            : video
                                                                                                .header
                                                                                                .document_name
                                                                                        ) +
                                                                                        "\n                                "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "video_detail"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                  " +
                                                                                        _vm._s(
                                                                                          _vm._f(
                                                                                            "formatDate"
                                                                                          )(
                                                                                            video
                                                                                              .header
                                                                                              .created_on
                                                                                          )
                                                                                        ) +
                                                                                        "\n                                "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                ],
                                                                _vm._v(" "),
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value:
                                                                            _vm.currentName ==
                                                                            _vm.$t(
                                                                              "litter_helper.FAQ"
                                                                            ),
                                                                          expression:
                                                                            "currentName == $t('litter_helper.FAQ')"
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "faq",
                                                                      on: {
                                                                        click:
                                                                          _vm.previewImgHandler
                                                                      }
                                                                    },
                                                                    _vm._l(
                                                                      _vm.faq_list(
                                                                        phase[
                                                                          role
                                                                        ]
                                                                      ),
                                                                      function(
                                                                        content,
                                                                        index
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            key:
                                                                              content
                                                                                .header
                                                                                .document_id,
                                                                            ref:
                                                                              "document_" +
                                                                              content
                                                                                .header
                                                                                .document_id,
                                                                            refInFor: true,
                                                                            staticClass:
                                                                              "document_title",
                                                                            staticStyle: {
                                                                              "margin-bottom":
                                                                                "15px"
                                                                            },
                                                                            attrs: {
                                                                              "data-role": role
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "question"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      cursor:
                                                                                        "pointer"
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.getDocumentDetail(
                                                                                          content
                                                                                            .header
                                                                                            .document_id,
                                                                                          index,
                                                                                          role
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "text-highlight",
                                                                                      {
                                                                                        attrs: {
                                                                                          queries:
                                                                                            _vm.hight_words
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n                                    " +
                                                                                            _vm._s(
                                                                                              content.title
                                                                                            ) +
                                                                                            "\n                                  "
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                ]
                                                              ]
                                                        ],
                                                        2
                                                      )
                                                    : _vm._e()
                                                ]
                                              })
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    }),
                                    0
                                  )
                                ]
                              : [
                                  _c("div", { staticClass: "question" }, [
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          "font-size": "25px",
                                          "margin-bottom": "35px"
                                        }
                                      },
                                      [
                                        _c(
                                          "text-highlight",
                                          {
                                            attrs: { queries: _vm.hight_words }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(_vm.question) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "answer",
                                    staticStyle: { "padding-right": "35px" },
                                    domProps: { innerHTML: _vm._s(_vm.answer) }
                                  })
                                ]
                          ]
                        : [
                            _c("div", { staticClass: "no_content" }, [
                              _c("div", [
                                _c("img", {
                                  attrs: {
                                    src:
                                      "../../static/images/" +
                                      (_vm.isSearch
                                        ? "no_search"
                                        : "no_content") +
                                      ".svg",
                                    alt: ""
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "litter_helper." +
                                          (_vm.isSearch
                                            ? "no_search"
                                            : "no_content")
                                      )
                                    ) +
                                    "\n              "
                                )
                              ])
                            ])
                          ]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "inquiry",
                      staticClass: "inquiry",
                      style: {
                        justifyContent:
                          _vm.isSolve === true ? "center" : "space-between"
                      }
                    },
                    [
                      _vm.isSolve !== true
                        ? [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../static/images/excl_mark.svg"),
                                    height: "25px",
                                    alt: ""
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isSolve !== false,
                                        expression: "isSolve !== false"
                                      }
                                    ],
                                    staticStyle: {
                                      flex: "1",
                                      "flex-wrap": "wrap",
                                      margin: "0 10px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("litter_helper.solve_problem")
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isSolve === false,
                                        expression: "isSolve === false"
                                      }
                                    ],
                                    staticStyle: {
                                      flex: "1",
                                      "flex-wrap": "wrap",
                                      margin: "0 10px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("litter_helper.send_email")
                                        ) +
                                        "\n                "
                                    ),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "mailto: emoment.service@nike.com"
                                        }
                                      },
                                      [_vm._v("emoment.service@nike.com")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("Icon", {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "margin-top": "5px"
                                  },
                                  attrs: {
                                    type: "md-close",
                                    color: "#fff",
                                    size: "20"
                                  },
                                  on: { click: _vm.closeInquiry }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isSolve !== false,
                                    expression: "isSolve !== false"
                                  }
                                ],
                                staticStyle: { "text-align": "right" }
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticStyle: {
                                      color: "#000",
                                      background: "#fff",
                                      "margin-right": "25px"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.solve_inquiry(true)
                                        _vm.isSolveClick()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "litter_helper.solve_problem_ok"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    on: {
                                      click: function($event) {
                                        _vm.show_send_email()
                                        _vm.isSolveClick()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "litter_helper.solve_problem_no"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isSolve === false,
                                    expression: "isSolve === false"
                                  }
                                ]
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      color: "#000",
                                      background: "#fff",
                                      "margin-right": "25px"
                                    },
                                    on: { click: _vm.closeInquiry }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("litter_helper.i_know")) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        : [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-direction": "column",
                                  "justify-content": "center",
                                  "align-items": "center"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      position: "absolute",
                                      left: "16px",
                                      top: "10px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "litter_helper.close_inquiry",
                                            { count: _vm.count_down }
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("img", {
                                  staticStyle: {
                                    display: "block",
                                    "margin-bottom": "5px"
                                  },
                                  attrs: {
                                    src: require("../../static/images/笔芯.svg"),
                                    alt: ""
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(_vm.$t("litter_helper.feedback"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("Icon", {
                                  staticStyle: {
                                    position: "absolute",
                                    right: "16px",
                                    top: "10px",
                                    cursor: "pointer",
                                    "margin-top": "5px"
                                  },
                                  attrs: {
                                    type: "md-close",
                                    color: "#fff",
                                    size: "20"
                                  },
                                  on: { click: _vm.closeInquiry }
                                })
                              ],
                              1
                            )
                          ]
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentName && !_vm.isSearch,
                      expression: "currentName && !isSearch"
                    }
                  ],
                  staticClass: "catalog",
                  on: { click: _vm.showCatalog }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                      attrs: { title: _vm.$t("litter_helper.catalog") }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../../static/images/catalog.svg"),
                          alt: ""
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "Drawer",
                {
                  ref: "drawer",
                  attrs: { closable: false, placement: "left", width: "310" },
                  model: {
                    value: _vm.isShowCatalog,
                    callback: function($$v) {
                      _vm.isShowCatalog = $$v
                    },
                    expression: "isShowCatalog"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "catalogDrawer",
                      staticStyle: {
                        "font-weight": "600",
                        "font-size": "20px",
                        color: "#000"
                      },
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c("div", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("litter_helper.catalog")) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("Icon", {
                        staticStyle: { cursor: "pointer" },
                        attrs: { size: "30", type: "ios-close" },
                        on: {
                          click: function($event) {
                            _vm.isShowCatalog = false
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { on: { click: _vm.catalogSkip } },
                    _vm._l(_vm.phaseList, function(phase) {
                      return _vm.filter_phase(phase)
                        ? _c(
                            "div",
                            {
                              key: phase.stage,
                              staticClass: "phase",
                              staticStyle: { "margin-bottom": "15px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "23px",
                                    "font-weight": "600",
                                    "margin-bottom": "5px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("litter_helper." + phase.stage)
                                      ) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.user_roles, function(role) {
                                return [
                                  phase[role].length > 0
                                    ? _c(
                                        "div",
                                        { key: role },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-weight": "600",
                                                "margin-left": "18px",
                                                "font-size": "20px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "litter_helper." + role
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.currentName ==
                                          _vm.$t("litter_helper.user_manual")
                                            ? _vm._l(
                                                _vm.user_manual_list(
                                                  phase[role]
                                                ),
                                                function(content) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        content.header
                                                          .document_id,
                                                      staticClass:
                                                        "catalog_title",
                                                      staticStyle: {
                                                        "margin-left": "38px",
                                                        "font-size": "18px",
                                                        "margin-bottom": "10px"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          class: {
                                                            catalogHight:
                                                              _vm.title_hight
                                                                .text ===
                                                                (content.title
                                                                  ? content.title
                                                                  : content
                                                                      .header
                                                                      .document_name) &&
                                                              _vm.title_hight
                                                                .parent === role
                                                          },
                                                          attrs: {
                                                            "data-el":
                                                              "document_" +
                                                              content.header
                                                                .document_id
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              content.title
                                                                ? content.title
                                                                : content.header
                                                                    .document_name
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            : _vm.currentName ==
                                              _vm.$t(
                                                "litter_helper.feature_description_video"
                                              )
                                            ? _vm._l(
                                                _vm.video_list(phase[role]),
                                                function(content) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        content.header
                                                          .document_id,
                                                      staticClass:
                                                        "catalog_title",
                                                      staticStyle: {
                                                        "margin-left": "38px",
                                                        "font-size": "18px",
                                                        "margin-bottom": "10px"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            "data-el":
                                                              "document_" +
                                                              content.header
                                                                .document_id
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              content.title
                                                                ? content.title
                                                                : content.header
                                                                    .document_name
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            : _vm._l(
                                                _vm.faq_list(phase[role]),
                                                function(content) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        content.header
                                                          .document_id,
                                                      staticClass:
                                                        "catalog_title",
                                                      staticStyle: {
                                                        "margin-left": "38px",
                                                        "margin-bottom": "10px",
                                                        "font-size": "18px"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          class: {
                                                            catalogHight:
                                                              _vm.title_hight
                                                                .text ===
                                                                (content.title
                                                                  ? content.title
                                                                  : content
                                                                      .header
                                                                      .document_name) &&
                                                              _vm.title_hight
                                                                .parent === role
                                                          },
                                                          attrs: {
                                                            "data-el":
                                                              "document_" +
                                                              content.header
                                                                .document_id
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              content.title
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    }),
                    0
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            draggable: "",
            sticky: "",
            scrollable: "",
            mask: false,
            title: _vm.video_title,
            width: "880px"
          },
          on: { "on-cancel": _vm.cancelVideoPlay },
          model: {
            value: _vm.videoShow,
            callback: function($$v) {
              _vm.videoShow = $$v
            },
            expression: "videoShow"
          }
        },
        [
          _c("videoPlayer", {
            ref: "helpAliyunPlayer",
            staticStyle: { height: "495px" },
            attrs: { isWaterMark: true, playerWrapId: "helpLitterVideo" }
          }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            "footer-hide": "",
            closable: false,
            width: "800px",
            "mask-closable": false,
            styles: {
              top: "calc((100vh - 660px) / 2)"
            }
          },
          model: {
            value: _vm.is_send_email,
            callback: function($$v) {
              _vm.is_send_email = $$v
            },
            expression: "is_send_email"
          }
        },
        [
          _c(
            "div",
            { staticClass: "header", staticStyle: { "margin-bottom": "15px" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between"
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "font-size": "20px", color: "#111" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("litter_helper.faq_feedback")) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("Icon", {
                    staticStyle: { "margin-left": "15px", cursor: "pointer" },
                    attrs: { slot: "prefix", type: "md-close", size: "25" },
                    on: {
                      click: function($event) {
                        _vm.is_send_email = false
                        _vm.is_feedback_success = false
                      }
                    },
                    slot: "prefix"
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.is_feedback_success,
                  expression: "!is_feedback_success"
                }
              ]
            },
            [
              _c(
                "div",
                [
                  _c("Input", {
                    attrs: {
                      type: "textarea",
                      rows: 6,
                      placeholder: _vm.$t("litter_helper.enter_question")
                    },
                    model: {
                      value: _vm.email_content,
                      callback: function($$v) {
                        _vm.email_content = $$v
                      },
                      expression: "email_content"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { "margin-top": "20px", "text-align": "right" }
                },
                [
                  _c(
                    "Button",
                    {
                      staticStyle: { "margin-right": "15px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.sendEmailHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("session.QA.commit")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "Button",
                    {
                      attrs: { type: "default" },
                      on: {
                        click: function($event) {
                          _vm.is_send_email = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("session.cancel")))]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.is_feedback_success,
                  expression: "is_feedback_success"
                }
              ],
              staticStyle: {
                "font-size": "25px",
                height: "188px",
                display: "flex",
                "align-items": "center"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "center",
                    width: "100%"
                  }
                },
                [
                  _c("Icon", {
                    attrs: {
                      type: "ios-checkmark-circle",
                      color: "#14ce14",
                      size: "30"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "margin-left": "5px" } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("litter_helper.successful_problem_feedback")
                        ) +
                        "\n        "
                    )
                  ])
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isPreviewImg,
            expression: "isPreviewImg"
          }
        ],
        staticClass: "black_overlay",
        attrs: { id: "black_overlay" }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isPreviewImg,
              expression: "isPreviewImg"
            }
          ],
          staticClass: "enlargeContainer",
          attrs: { id: "enlargeContainer" }
        },
        [
          _c("img", {
            staticClass: "enlargePreviewImg",
            attrs: { src: _vm.previewImg }
          }),
          _vm._v(" "),
          _c("Icon", {
            staticClass: "previewClose",
            attrs: { color: "#fff", size: "30", type: "md-close" },
            on: {
              click: function($event) {
                _vm.isPreviewImg = false
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "align-items": "center" } },
      [
        _c("img", {
          attrs: { src: require("../../static/images/help_fill.svg"), alt: "" }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe1dfbfa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe1dfbfa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/litter_helper.vue
// module id = null
// module chunks = 